import React from "react";
import { Container, Row, Col } from "shards-react";
import WardManagement from "../components/manage-wards/WardManagement";

class ManageWards extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <Container fluid className="main-content-container px-4">
                <Row className="py-3">
                    <Col lg="12">
                        <WardManagement />
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default ManageWards;